var _style, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _polyline, _polyline2, _polyline3, _polyline4, _polyline5, _polyline6, _polyline7, _polyline8, _polyline9, _polyline10, _polyline11, _polyline12, _polyline13, _polyline14, _polyline15, _text, _text2, _text3, _line32, _line33, _polyline16, _line34, _line35, _line36, _line37, _polyline17, _line38, _line39, _line40, _line41, _line42, _line43, _line44, _line45, _polyline18, _line46, _line47, _line48, _line49, _line50, _line51, _line52, _line53, _line54, _line55, _line56, _line57, _line58, _line59, _line60, _line61, _line62, _line63, _line64, _line65, _line66, _line67, _line68, _line69, _line70, _line71, _line72, _line73, _polyline19, _line74, _line75, _line76, _line77, _line78, _line79, _line80, _line81, _line82, _line83, _line84, _line85, _polyline20, _polyline21, _line86, _line87, _line88, _line89, _line90, _line91, _line92, _line93, _line94, _line95, _line96, _line97, _line98, _line99, _polyline22, _line100, _polyline23, _line101, _polyline24, _line102, _text4, _text5, _text6, _text7, _text8, _text9, _text10, _text11, _text12, _text13, _text14, _text15, _text16, _text17, _text18, _text19, _text20, _text21, _text22, _text23;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPavilionBigRasterFr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "1017.7px",
    height: "800.7px",
    viewBox: "0 0 1017.7 800.7",
    style: {
      enableBackground: "new 0 0 1017.7 800.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#000000;stroke-width:0.196;stroke-linecap:round;stroke-linejoin:round;}\n\t.st1{fill:none;stroke:#EF3E23;stroke-width:0.49;stroke-linecap:round;stroke-linejoin:round;}\n\t.st2{font-family:'AAHA-WEB';}\n\t.st3{font-size:11.76px;}\n\t.st4{letter-spacing:24;}\n")), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 1136,
    height: 1580,
    xlinkHref: "/img/pavilion.png",
    transform: "matrix(0.48 0 0 0.48 235.2 22.14)"
  }), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 255.3,
    y1: 474.6,
    x2: 253.1,
    y2: 473
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 247,
    y1: 412.3,
    x2: 246.6,
    y2: 411.9
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 246.6,
    y1: 410.7,
    x2: 246.6,
    y2: 411.9
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 247,
    y1: 412.3,
    x2: 247,
    y2: 414.3
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 247,
    y1: 414.3,
    x2: 249,
    y2: 414.2
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 249,
    y1: 414.2,
    x2: 249,
    y2: 412.3
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 253.3,
    y1: 472.6,
    x2: 255,
    y2: 473.8
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 250,
    y1: 469.2,
    x2: 252.5,
    y2: 471
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 252.5,
    y1: 472.1,
    x2: 249,
    y2: 469.6
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 252.4,
    y1: 472.4,
    x2: 248.9,
    y2: 469.9
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 249,
    y1: 469.6,
    x2: 249,
    y2: 469.3
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 249,
    y1: 469.6,
    x2: 248.9,
    y2: 469.9
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 252.5,
    y1: 472.1,
    x2: 252.4,
    y2: 472.4
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 252.5,
    y1: 471.8,
    x2: 253.1,
    y2: 472.2
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 253.1,
    y1: 472.2,
    x2: 253.2,
    y2: 472.5
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 253.3,
    y1: 472.6,
    x2: 253.1,
    y2: 472.5
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 252.5,
    y1: 472.1,
    x2: 255.1,
    y2: 474
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 254.2,
    y1: 471.7,
    x2: 252.5,
    y2: 471.8
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 247.3,
    y1: 469.5,
    x2: 247.4,
    y2: 469.6
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 253.2,
    y1: 472.5,
    x2: 254.5,
    y2: 472.4
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 248.9,
    y1: 469.9,
    x2: 247.4,
    y2: 469.6
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 251.3,
    y1: 472.4,
    x2: 247.4,
    y2: 469.6
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 251.3,
    y1: 472.4,
    x2: 252.4,
    y2: 472.4
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 252.4,
    y1: 473.2,
    x2: 251.3,
    y2: 472.4
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 252.6,
    y1: 473.1,
    x2: 252.6,
    y2: 473.1
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 245.3,
    y1: 468.1,
    x2: 245.3,
    y2: 467.3
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 254.5,
    y1: 472.6,
    x2: 253.3,
    y2: 472.6
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 255.3,
    y1: 474.5,
    x2: 252.4,
    y2: 472.4
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 254.4,
    y1: 472.2,
    x2: 253.1,
    y2: 472.2
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 252.5,
    y1: 472.1,
    x2: 252.5,
    y2: 471
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 247.4,
    y1: 469.5,
    x2: 245.6,
    y2: 468.7
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "599.9,647.8 794.4,594.8 839.1,594.8 "
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "297.8,560.6 202.9,543.2 180.9,543.2 "
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "351.8,165.9 195.6,456 154.3,456 "
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "583.2,314.5 797.4,311.7 839.1,311.7 "
  })), _polyline5 || (_polyline5 = /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "272.7,485.8 202.9,505.1 160.1,505.1 "
  })), _polyline6 || (_polyline6 = /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "343.4,637.5 202.9,690.2 113.6,690.2 "
  })), _polyline7 || (_polyline7 = /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "645.3,490.9 794.4,367.6 839.1,367.6 "
  })), _polyline8 || (_polyline8 = /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "533.7,544.6 794.4,511.2 839.1,511.2 "
  })), _polyline9 || (_polyline9 = /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "612.9,689.3 794.4,667 839.1,667 "
  })), _polyline10 || (_polyline10 = /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "532.6,754.5 793.3,722.8 838,722.8 "
  })), _polyline11 || (_polyline11 = /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "607.4,212.2 790.2,256.6 839.1,256.6 "
  })), _polyline12 || (_polyline12 = /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "713.4,157.4 790.2,201.7 839.1,201.7 "
  })), _polyline13 || (_polyline13 = /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "493.4,615 202.9,748.8 113.6,748.8 "
  })), _polyline14 || (_polyline14 = /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "398.8,569.9 202.9,642.1 169.6,642.1 "
  })), _polyline15 || (_polyline15 = /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "658.2,497.1 794.4,432.5 839.1,432.5 "
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 116.6838 547.4995)",
    className: "st2 st3 st4"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 144.7839 547.4995)",
    className: "st2 st3"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 150.1198 541.498)",
    className: "st2 st3"
  }, "FILM")), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 248.8,
    y1: 466.9,
    x2: 246.6,
    y2: 465.3
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 236.4,
    y1: 474,
    x2: 242.2,
    y2: 471.4
  })), _polyline16 || (_polyline16 = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "236.7,470 238.2,469.9 239.7,469.9 241.1,469.9 242.6,469.9 244.1,469.9 245.6,469.8 "
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 236.6,
    y1: 464.6,
    x2: 244.3,
    y2: 465.1
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 236.6,
    y1: 465.9,
    x2: 235.7,
    y2: 465.9
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 252.2,
    y1: 473.2,
    x2: 249.3,
    y2: 471.1
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 249.3,
    y1: 471.1,
    x2: 249.7,
    y2: 472.1
  })), _polyline17 || (_polyline17 = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "236.7,470 236.7,468.6 236.7,467.2 "
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 245.6,
    y1: 474.8,
    x2: 246.5,
    y2: 474.8
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 249.1,
    y1: 466.6,
    x2: 249.2,
    y2: 466.9
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 249.1,
    y1: 466.6,
    x2: 249.5,
    y2: 466.9
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 243.4,
    y1: 474.7,
    x2: 243.5,
    y2: 475.2
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 246.6,
    y1: 465.3,
    x2: 246.6,
    y2: 465.3
  })), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 249.5,
    y1: 473.2,
    x2: 249.7,
    y2: 472.1
  })), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 249.1,
    y1: 466.6,
    x2: 248.6,
    y2: 466.8
  })), _line45 || (_line45 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 246.5,
    y1: 471,
    x2: 244.7,
    y2: 466.7
  })), _polyline18 || (_polyline18 = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "244.7,466.7 245.2,468.3 245.6,469.8 "
  })), _line46 || (_line46 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 246.6,
    y1: 465.3,
    x2: 247.3,
    y2: 467.1
  })), _line47 || (_line47 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 245.3,
    y1: 474.2,
    x2: 249.3,
    y2: 474.3
  })), _line48 || (_line48 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 237.3,
    y1: 474.6,
    x2: 243.6,
    y2: 474.7
  })), _line49 || (_line49 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 245.7,
    y1: 475.1,
    x2: 246.5,
    y2: 474.8
  })), _line50 || (_line50 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 249.8,
    y1: 473.9,
    x2: 248.5,
    y2: 470.5
  })), _line51 || (_line51 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 247.3,
    y1: 467.1,
    x2: 246.6,
    y2: 465.3
  })), _line52 || (_line52 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 242.6,
    y1: 469.9,
    x2: 241.8,
    y2: 470.3
  })), _line53 || (_line53 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 245.7,
    y1: 467.3,
    x2: 244.8,
    y2: 465
  })), _line54 || (_line54 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 250.3,
    y1: 473.8,
    x2: 249.7,
    y2: 472.1
  })), _line55 || (_line55 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 239,
    y1: 477.5,
    x2: 247.5,
    y2: 485.3
  })), _line56 || (_line56 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 243.5,
    y1: 475.3,
    x2: 243.5,
    y2: 475.2
  })), _line57 || (_line57 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 236.7,
    y1: 467.2,
    x2: 238.2,
    y2: 465.7
  })), _line58 || (_line58 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 236.7,
    y1: 465.4,
    x2: 236.6,
    y2: 471.3
  })), _line59 || (_line59 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 236.7,
    y1: 467.2,
    x2: 236.7,
    y2: 465.4
  })), _line60 || (_line60 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 236.7,
    y1: 467.2,
    x2: 236.7,
    y2: 465.8
  })), _line61 || (_line61 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 236.5,
    y1: 472.7,
    x2: 236.7,
    y2: 465.4
  })), _line62 || (_line62 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 243.3,
    y1: 470.9,
    x2: 245.6,
    y2: 469.8
  })), _line63 || (_line63 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 236.7,
    y1: 468.6,
    x2: 238.2,
    y2: 469.9
  })), _line64 || (_line64 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 239.2,
    y1: 468.6,
    x2: 236.7,
    y2: 467.2
  })), _line65 || (_line65 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 246.6,
    y1: 469.1,
    x2: 247.5,
    y2: 472.1
  })), _line66 || (_line66 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 236.6,
    y1: 465.7,
    x2: 235.7,
    y2: 465.8
  })), _line67 || (_line67 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 235.7,
    y1: 465.9,
    x2: 235.9,
    y2: 475.5
  })), _line68 || (_line68 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 236.6,
    y1: 464.6,
    x2: 245.7,
    y2: 464.6
  })), _line69 || (_line69 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 243.5,
    y1: 475.2,
    x2: 235.9,
    y2: 475.5
  })), _line70 || (_line70 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 235.9,
    y1: 475.5,
    x2: 235.9,
    y2: 475.6
  })), _line71 || (_line71 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 253.2,
    y1: 473.3,
    x2: 252.9,
    y2: 473.1
  })), _line72 || (_line72 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 249.5,
    y1: 474,
    x2: 252.9,
    y2: 473.1
  })), _line73 || (_line73 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 246.5,
    y1: 474.8,
    x2: 248.5,
    y2: 474.3
  })), _polyline19 || (_polyline19 = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "243.5,475.3 243.5,475.3 235.9,475.6 "
  })), _line74 || (_line74 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 237.3,
    y1: 474.6,
    x2: 236.4,
    y2: 474
  })), _line75 || (_line75 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 246.6,
    y1: 465.3,
    x2: 245.7,
    y2: 464.6
  })), _line76 || (_line76 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 244.7,
    y1: 466.7,
    x2: 244.3,
    y2: 465.1
  })), _line77 || (_line77 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 244.8,
    y1: 465,
    x2: 244.3,
    y2: 465.1
  })), _line78 || (_line78 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 247.5,
    y1: 472.1,
    x2: 246.3,
    y2: 469
  })), _line79 || (_line79 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 246.5,
    y1: 471,
    x2: 245.6,
    y2: 469.8
  })), _line80 || (_line80 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 246.5,
    y1: 471,
    x2: 247.5,
    y2: 472.1
  })), _line81 || (_line81 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 245.3,
    y1: 464.8,
    x2: 244.8,
    y2: 465
  })), _line82 || (_line82 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 245.3,
    y1: 464.8,
    x2: 246,
    y2: 467.2
  })), _line83 || (_line83 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 245.3,
    y1: 464.8,
    x2: 245.7,
    y2: 464.6
  })), _line84 || (_line84 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 248.4,
    y1: 473.2,
    x2: 247.5,
    y2: 472.1
  })), _line85 || (_line85 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 248.4,
    y1: 473.2,
    x2: 249.3,
    y2: 474.3
  })), _polyline20 || (_polyline20 = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "244.3,465.1 242.8,465.3 241.3,465.4 239.7,465.5 238.2,465.7 236.7,465.8 "
  })), _polyline21 || (_polyline21 = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "236.6,464.6 236.6,465 236.7,465.4 236.7,465.8 "
  })), _line86 || (_line86 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 240.8,
    y1: 467.7,
    x2: 238.2,
    y2: 465.7
  })), _line87 || (_line87 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 240.8,
    y1: 467.7,
    x2: 245.2,
    y2: 468.3
  })), _line88 || (_line88 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 242.8,
    y1: 465.3,
    x2: 240.8,
    y2: 467.7
  })), _line89 || (_line89 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 244.7,
    y1: 466.7,
    x2: 240.8,
    y2: 467.7
  })), _line90 || (_line90 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 244.7,
    y1: 466.7,
    x2: 242.8,
    y2: 465.3
  })), _line91 || (_line91 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 239.2,
    y1: 468.6,
    x2: 240.8,
    y2: 467.7
  })), _line92 || (_line92 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 241.7,
    y1: 468.8,
    x2: 244.1,
    y2: 469.9
  })), _line93 || (_line93 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 241.7,
    y1: 468.8,
    x2: 245.2,
    y2: 468.3
  })), _line94 || (_line94 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 241.1,
    y1: 469.9,
    x2: 239.2,
    y2: 468.6
  })), _line95 || (_line95 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 236.6,
    y1: 471.3,
    x2: 236.7,
    y2: 470
  })), _line96 || (_line96 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 236.7,
    y1: 467.2,
    x2: 236.6,
    y2: 471.3
  })), _line97 || (_line97 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 236.5,
    y1: 472.7,
    x2: 236.6,
    y2: 471.3
  })), _line98 || (_line98 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 236.5,
    y1: 472.7,
    x2: 236.4,
    y2: 474
  })), _line99 || (_line99 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 236.4,
    y1: 474,
    x2: 243.3,
    y2: 474.1
  })), _polyline22 || (_polyline22 = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "236.4,474 236.5,472.1 236.5,470.2 236.5,468.4 236.6,466.5 236.6,464.6 "
  })), _line100 || (_line100 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 249.7,
    y1: 472.1,
    x2: 251.5,
    y2: 473.4
  })), _polyline23 || (_polyline23 = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "246.7,467.2 246.3,466.3 245.7,464.6 "
  })), _line101 || (_line101 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 249.4,
    y1: 471.1,
    x2: 249.3,
    y2: 471.1
  })), _polyline24 || (_polyline24 = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "249.3,474.3 248.7,472.7 248.1,471.1 247.7,469.8 "
  })), _line102 || (_line102 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 235.7,
    y1: 465.9,
    x2: 235.7,
    y2: 465.8
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 20.4956 692.4634)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st2 st3"
  }, "BANCS MOBILES"))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 31.4954 753.311)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st2 st3"
  }, "BANCS FIXES"))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 7.4955 643.0581)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st2 st3"
  }, "CALENDRIERDE LA CAMPAGNE"))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 7.4952 460.5181)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st2 st3"
  }, "ENTREP\xD4T SOUS L'ES CALIER"))), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1.005 848.9053 205.7886)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st2 st3"
  }, "BANDEROLES POUR FUGITIFS"))), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 848.905 315.9742)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st2 st3"
  }, "STOP THE SWEEPS PALISSADE"))), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 7.5007 509.9199)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st2 st3"
  }, "ENTREP\xD4T DE LA CAMPAGNE"))), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 47.5008 552.7666)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st2 st3"
  }, "ATLAS DE L'ALI\xC9NATION"))), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 57.2729 564.209)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st2 st3"
  }, "DU LOGEMENT"))), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 858.9053 254.9136)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st2 st3"
  }, "BUREAU DE TRAVAIL"))), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 848.9053 265.9136)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st2 st3"
  }, "COLLABORATIF"))), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 848.9048 371.0347)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st2 st3"
  }, "CARTE DE LA CAMPAGNE"))), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 848.9051 426.0952)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st2 st3"
  }, "BUREAU FIXE AVEC"))), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 848.9052 437.5367)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st2 st3"
  }, "ORDINATEUR PORTABLE"))), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 848.905 504.0406)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st2 st3"
  }, "COUR DE LA RESTITUTION DE"))), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 848.9051 515.482)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st2 st3"
  }, "TERRES ANCESTRALES"))), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 848.905 593.4273)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st2 st3"
  }, "MURS D\u2019ACCROCHAGE AVEC"))), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 848.9051 604.8707)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st2 st3"
  }, "LES NEUF PROJETS"))), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 848.905 671.3726)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st2 st3"
  }, "DEUX TABLES \xC0"))), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 848.9053 726.4332)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st2 st3"
  }, "DIX BANNI\xC8RES DES DEMANDES"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPavilionBigRasterFr);
export default __webpack_public_path__ + "static/media/pavilionBigRaster_fr.a3a2d973c216cf1f8e6be3065816adab.svg";
export { ForwardRef as ReactComponent };